import FieldsModel from './FieldsModel';

export default class CampaignQRCodeItemModel {
  constructor() {
    this.fields = new FieldsModel();

    this.id = '';

    this.url = '';
  }

  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'fields')) {
      this['fields'].getData(dataSource['fields']);
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'id')) {
      this['id'] = dataSource['id'];
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'url')) {
      this['url'] = dataSource['url'];
    }

    return this;
  }
}
